import { render, staticRenderFns } from "./NewOptionForm.vue?vue&type=template&id=648281b6"
import script from "./NewOptionForm.vue?vue&type=script&lang=js"
export * from "./NewOptionForm.vue?vue&type=script&lang=js"
import style0 from "./NewOptionForm.vue?vue&type=style&index=0&id=648281b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports